import React, {useState, useEffect} from 'react';
import DatePicker from "react-datepicker";
import Box from '../ui/Box.js';
import api from '../../api/index.js';
import './wagehistory.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css' // Import css
import ConfirmUI from '../../components/ui/Confirm.js';

const WageHistory = (props) => {
	
	const [wagedata, setWagedata] = useState([]);
	const [employee, setEmployee] = useState(false);
	const [tableOpen, setTableOpen] = useState(false);
	const [rate, changeRate] = useState('');
	const [effectiveDate, changeEffectiveDate] = useState(new Date());
	
	const refresh = async () => {
		try {
			let data = await api.get('employees/' + props.EmployeeID + '/wage-history');
			setWagedata(data);
		} catch(e) {
			api.handleExceptions(e);
		};
	}

	useEffect(() => {
		if (employee !== props.EmployeeID) {
			setEmployee(props.EmployeeID);
			refresh();
		}
	});
	
	//const wage = wagedata.length > 0 ? wagedata[0].Rate.moneyFormat() : '?';
	
	const actuallyDeleteEntry = async(wage) => {
		try {
			let r = await api.del('employees/' + props.EmployeeID + '/wage-history', wage);
			api.success('Employee wage updated', r);
			if (props.onUpdated)
				props.onUpdated(props.EmployeeID);
			refresh();
		} catch(e) {
			api.handleExceptions(e);
		};
	}
	
	const deleteEntry = async(e, i) => {
		e.preventDefault();
		const wage = wagedata[i];
		if (wage['class'] == 'hourly-wage') { // There's no reason to delete minimum wages atm
			confirmAlert({
				title: 'Delete this rate: $'  + wage['Rate'].moneyFormat() + ' from ' + wage['EffectiveDate'],
				customUI: ConfirmUI(
					()=>{actuallyDeleteEntry(wage)},
					<div><p>This will remove the rate from this employee.</p><p><em>Are you sure to remove this rate?</em></p></div>
				),
			});
		}
	}

	const save = async (e) => {
		e.preventDefault();
		
		const data = {
			EffectiveDate: effectiveDate,
			Rate: rate,
		};
		try {
			let r = await api.put('employees/' + props.EmployeeID + '/wage-history', data);
			api.success('Employee wage updated', r);
			if (props.onUpdated)
				props.onUpdated(props.EmployeeID);
			refresh();
		} catch(e) {
			api.handleExceptions(e);
		};
	}
	
	return <span className={(props.className || '') + ' WageHistory '}>
		<button className="clear" onClick={()=>setTableOpen(true)}>${props.placeholder === false ? '' : props.placeholder.moneyFormat()}</button>
		
		<Box 
			modal={true}
			isOpen={tableOpen}
			onRequestClose={()=>setTableOpen(false)}
			title="WageHistory"
		>
			<form className="WageHistoryForm" onSubmit={save}>
				<label>EffectiveDate</label>
				<DatePicker
					className="EffectiveDate"
					selected={effectiveDate}
					onChange={(e)=>changeEffectiveDate(e)}
				/>
				<label>Rate</label>
				<input type="text" name="Rate" placeholder="Rate" value={rate} onChange={(e)=>changeRate(e.target.value)} />
				<button className="block" type="submit">Save</button>
			</form>
			<hr />
			<table className="WageHistoryTable data-table">
				<thead>
					<tr>
						<th>Effective Date</th><th>Rate</th>
					</tr>
				</thead>
				<tbody>
				{wagedata.map(function(a, i) {
					return <tr key={i} className={a['class']}><td>{a.EffectiveDate}</td><td>${a.Rate.moneyFormat()}</td><td className="delete-button"><button className="clear" title="Delete entry" onClick={(e)=>deleteEntry(e, i)}><FontAwesomeIcon icon={faTrashAlt} className="deleteIcon" /></button></td></tr>;
				})}
				</tbody>
			</table>
		</Box>
	</span>;
}
export default WageHistory;